import React, { useEffect, useState, useRef } from "react";
import { TextArea } from "../Elements";
import { Button } from "react-bootstrap";
import AiIcon from "../../assets/icons/svg/AI-icon.svg?react";
import { AiTrasnformterScript } from "../../utils";

const transformers = [
  "Short & Concise",
  "Factual",
  "Conversational",
  "Dramatic",
  "Viral",
  "Custom Prompt",
];

interface Props {
  onSelect?: any;
  type?: string;
  defaultValue?: string;
  item?: any;
  isChecked?: boolean;
  handleCheckboxChange?: (checked: boolean) => void;
  disabled?: boolean;
  isPreview?: boolean;
  readOnlyMode?: boolean;
  labelType?: string;
}

const AiTransformer = ({
  onSelect,
  type,
  defaultValue,
  item,
  isChecked,
  handleCheckboxChange,
  disabled,
  isPreview = false,
  readOnlyMode = false,
  labelType,
}: Props) => {
  const [selected, setSelected] = useState<string | null>(type || null);
  const [customPrompt, setCustomPrompt] = useState<string>("");
  const [translateLanguage, setTranslateLanguage] = useState<string>("");
  const [isTranslateOpen, setIsTranslateOpen] = useState<boolean>(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [key, setKey] = useState<string>(type || "");
  const [value, setValue] = useState<string>(defaultValue || "");

  const isPreviewList = [type];

  useEffect(() => {
    if (type) {
      setSelected(type);
      setValue(defaultValue || "");
    }
  }, [type, defaultValue]);

  const handleLanguageSelect = (language: string) => {
    setTranslateLanguage(language);
    setIsTranslateOpen(false);
  };

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const handleWheel = (e: React.WheelEvent) => {
    if (scrollContainerRef.current) {
      const scrollAmount = e.deltaX !== 0 ? e.deltaX : e.deltaY;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (selected === "Translate") {
      setIsTranslateOpen(!isTranslateOpen);
    } else {
      setIsTranslateOpen(false);
    }
  }, [selected]);

  useEffect(() => {
    onSelect({ key, value });
  }, [key, value]);

  return (
    <div className="pb-2">
      {/* <input className="form-check-input me-2" type="checkbox" checked readOnly /> */}
      <div className="form-check-label my-3">
        {!readOnlyMode && (
          <input
            className="form-check-input me-2"
            type="checkbox"
            checked={isChecked}
            onChange={(e) => handleCheckboxChange?.(e.target.checked)}
            readOnly
          />
        )}
        <AiIcon /> AI TRANSFORMER
      </div>

      <div className="position-relative ms-3">
        <div
          ref={scrollContainerRef}
          className="d-flex gap-2 overflow-x-auto"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          onWheel={handleWheel}
        >
          {!isPreview
            ? transformers.map((item) => (
                <button
                  key={item}
                  className={` flex-shrink-0 ai-chip
                ${
                  selected === item && isChecked
                    ? "active"
                    : !isChecked
                    ? "text-muted"
                    : "text-dark"
                }`}
                  style={{ backgroundColor: isChecked ? "" : "white" }}
                  disabled={disabled || !isChecked}
                  onClick={() => {
                    if (selected === item) {
                      // If same item is clicked, deselect it
                      setSelected(null);
                      setKey("");
                      // setValue('');
                    } else {
                      // Select the new item
                      setSelected(item);
                      setKey(item);
                      if (item !== "Custom Prompt" && item !== "Translate")
                        setValue(AiTrasnformterScript(item, labelType || ""));
                    }
                  }}
                >
                  {item}
                </button>
              ))
            : isPreviewList.map((item) => (
                <button
                  key={item}
                  className={` flex-shrink-0 ai-chip
                ${selected === item && isChecked ? "active" : "text-dark"} `}
                  // style={{ color: isChecked ? 'gray' : 'black' }}
                  disabled={disabled}
                  onClick={() => {
                    if (selected === item) {
                      // If same item is clicked, deselect it
                      setSelected(null);
                      setKey("");
                    } else {
                      // Select the new item
                      setSelected(item || "");
                      setKey(item || "");
                    }
                  }}
                >
                  {item}
                </button>
              ))}
        </div>
        {!isPreview && (
          <button
            onClick={handleScrollRight}
            className="position-absolute top-50 end-0 translate-middle-y bg-white border-0 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
            style={{ width: "32px", height: "32px", zIndex: 1 }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
      {selected === "Custom Prompt" && (
        <div className="mt-2">
          {isPreview ? (
            <span>{value}</span>
          ) : (
            <TextArea
              label="Custom Prompt"
              name="custom_prompt"
              placeholder="Enter your custom prompt here..."
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onBlur={() => {}}
              showRequired={false}
              disabled={disabled}
            />
          )}
        </div>
      )}

      {isTranslateOpen && (
        <div className="mt-2">
          <div
            className="bg-white border rounded shadow-sm"
            style={{ maxWidth: "150px" }}
          >
            <ul className="list-unstyled mb-0">
              {["English", "Hindi", "Bengali", "Tamil", "Telugu"].map(
                (lang) => (
                  <li
                    key={lang}
                    className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleLanguageSelect(lang);
                      setKey(lang);
                    }}
                  >
                    {lang}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiTransformer;
